import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from "react-router";
import { ROUTES } from '../../../constant/routeConstant';
import { getListUser, getSearchRecommendation, getDetailUser, initiateUser, getCountry, getProvince, getDistrict, getSubDistrict, getUrbanVillage, initiateCountry, initiateProvince, initiateDistrict, initiateSubDistrict, getSearchResult, deleteUser } from '../../../service/admin/User/UserService';

export const useUser = () => {
    const { token } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const location = useLocation();

    const [list, setList] = useState()
    const [options, setOptions] = useState([])
    const [searchKeyword, setSearchKeyword] = useState()
    const [detailUser, setDetailUser] = useState();
    const [totalData, setTotalData] = useState();

    const [countryList, setCountryList] = useState()
    const [provinceList, setProvinceList] = useState()
    const [districtList, setDistrictList] = useState()
    const [subDistrictList, setSubDistrictList] = useState()
    const [urbanVillageList, setUrbanVillageList] = useState()
    const [statePageSize, setStatePageSize] = useState(10)
    const [pageLimit, setPageLimit] = useState(0);
    const [page, setPage] = useState(0);
    const [id, setId] = useState(null);
    const [sorting, setSorting] = useState("id asc")

    const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState(false)
    const [successModalOpen, setSuccessModalOpen] = useState(false)
    const [selectedUpdatedAt, setSelectedUpdatedAt] = useState()
    const [selectedUserId, setSelectedUserId] = useState()
    const [selectedUserName, setSelectedUserName] = useState()

    const [userManagementOpen, setUserManagementOpen] = useState(false);

    const [cannotDeleteError, setCannotDeleteError] = useState(false)

    const [currentPage, setCurrentPage] = useState(1)

    const dispatch = useDispatch();

    const toInviteList = () => {
        navigate(ROUTES.INVITATION.LIST)
    }

    const toUserDetail = (id) => {
        navigate(ROUTES.USER.DETAIL, {
            state: {
                id
            }
        })
    }

    const toUserList = () => {
        navigate(ROUTES.USER.LIST)
    }

    const doInitiateUser = async () => {
        try {
            const response = await initiateUser(token, null, dispatch);
            if (response && response.ok) {
                setTotalData(response?.data?.count_data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        doInitiateUser()
        doGetListUser(1, 10);

        // eslint-disable-next-line
    }, [])

    const handleChangeLimit = (page, value, selectedDepotId) => {
        setStatePageSize(value)
        setCurrentPage(page)
        handlePagination(page, value, selectedDepotId)
    }

    const handlePagination = (page, pageSize) => {
        doInitiateUser()
        doGetListUser(page, pageSize)
    }

    useEffect(() => {
        if (location?.state?.id) {
            setId(location?.state?.id)
        }

        // eslint-disable-next-line
    }, [id]);



    const doGetDetailUser = async (id) => {
        try {
            const response = await getDetailUser(token, null, id, dispatch);
            if (response && response.ok) {
                setDetailUser(response.data)
                console.log(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const onClear = () => {
        setOptions([])
        setSearchKeyword()
        doGetListUser(1, 10, sorting);
    }

    const doGetListUser = async (page, pageSize, sort) => {
        setSuccessModalOpen(false)

        //set default value
        setPageLimit(10)
        setPage(1)

        const param = `page=${page}&limit=${pageSize}&order=${typeof sort !== 'undefined' ? sort : 'id asc'}`

        try {
            const response = await getListUser(token, null, param, dispatch)
            if (response && response.ok) {
                setList(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doInitiateCountry = async () => {
        try {
            const response = await initiateCountry(token, null, dispatch);
            if (response && response.ok) {
                doGetCountry(response.data.count_data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doInitiateProvince = async () => {
        try {
            const response = await initiateProvince(token, null, dispatch);
            if (response && response.ok) {
                doGetProvince(response.data.count_data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doInitiateDistrict = async () => {
        try {
            const response = await initiateDistrict(token, null, dispatch);
            if (response && response.ok) {
                doGetDistrict(response.data.count_data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doDeleteUser = async (id, updated_at) => {
        try {
            const response = await deleteUser(token, null, id, updated_at, dispatch)
            if (response && response.ok) {
                setDeleteConfirmationModalOpen(false)
                setSuccessModalOpen(true)
                setSelectedUserId()
                setSelectedUserName()
            } else {
                setDeleteConfirmationModalOpen(false)
                setCannotDeleteError(true)
                setSelectedUserId()
                setSelectedUserName()
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doInitiateSubDistrict = async () => {
        try {
            const response = await initiateSubDistrict(token, null, dispatch);
            if (response && response.ok) {
                doGetSubDistrict(response.data.count_data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doInitiateUrbanVillage = async () => {
        try {
            const response = await initiateSubDistrict(token, null, dispatch);
            if (response && response.ok) {
                doGetUrbanVillage(response.data.count_data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetCountry = async (totalData) => {

        const data = {
            "page": 1,
            "limit": totalData,
            "order_by": "name asc"
        }

        try {
            const response = await getCountry(token, null, data, dispatch)
            if (response && response.ok) {
                setCountryList(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetProvince = async (totalData) => {

        const data = {
            "page": 1,
            "limit": totalData,
            "order_by": "name asc",
        }

        try {
            const response = await getProvince(token, null, data, dispatch)
            if (response && response.ok) {
                setProvinceList(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetDistrict = async (totalData) => {

        const data = {
            "page": 1,
            "limit": totalData,
            "order_by": "name asc",
        }

        try {
            const response = await getDistrict(token, null, data, dispatch)
            if (response && response.ok) {
                setDistrictList(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetSubDistrict = async (totalData) => {

        const data = {
            "page": 1,
            "limit": totalData,
            "order_by": "name asc",
        }

        try {
            const response = await getSubDistrict(token, null, data, dispatch)
            if (response && response.ok) {
                setSubDistrictList(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetUrbanVillage = async (totalData) => {

        const data = {
            "page": 1,
            "limit": totalData,
            "order_by": "name asc",
        }

        try {
            const response = await getUrbanVillage(token, null, data, dispatch)
            if (response && response.ok) {
                setUrbanVillageList(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doSearch = async (keyword) => {
        try {
            const response = await getSearchRecommendation(token, null, keyword, dispatch);
            if (response && response.ok) {
                console.log(response.data)
                setOptions(response.data.map((el) => ({
                    value: el.id,
                    label: el.value
                })))
            }
        } catch (error) {
            console.log(error)
        }
    }

    const onSelect = async (keyword) => {
        try {
            const response = await getSearchResult(token, null, keyword, dispatch);
            if (response && response.ok) {
                setList(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const onSearch = (value) => {
        if (value !== '') {
            setSearchKeyword(value)
            doSearch(value)
        } else {
            setSearchKeyword()
            setOptions([])
        }
    }

    const convertTimestamp = (timestamp, isSpecific) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const monthNumbers = ["01", "02", "03", "04", "05", "06",
            "07", "08", "09", "10", "11", "12"
        ];

        // Extract components from the timestamp string
        const year = timestamp?.substring(0, 4);
        const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
        const day = timestamp?.substring(8, 10);

        let dateFormat = new Date(year, month, day);

        if (isSpecific) {
            return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
        } else {
            return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
        }
    }

    const doSort = (sort) => {
        setSorting(sort);
        doGetListUser(1, 10, sort);
    }

    const toEdit = (data) => {
        navigate(ROUTES.USER.UPDATE, { state: { id: data, prevPage: location?.pathname } })
    }

    return {
        list,
        doSearch,
        options,
        doGetListUser,
        onSearch,
        onSelect,
        toInviteList,
        toUserDetail,
        toUserList,
        userManagementOpen,
        setUserManagementOpen,
        doGetDetailUser,
        detailUser,
        convertTimestamp,
        doInitiateUser,
        totalData,
        handlePagination,
        doGetCountry,
        doGetProvince,
        doGetDistrict,
        doGetSubDistrict,
        doGetUrbanVillage,
        countryList,
        provinceList,
        districtList,
        subDistrictList,
        urbanVillageList,
        doInitiateCountry,
        doInitiateProvince,
        doInitiateDistrict,
        doInitiateSubDistrict,
        doInitiateUrbanVillage,
        doSort,
        sorting,
        setSorting,
        searchKeyword,
        setStatePageSize,
        statePageSize,
        handleChangeLimit,
        pageLimit,
        page,
        toEdit,
        id,
        deleteConfirmationModalOpen,
        successModalOpen,
        selectedUpdatedAt,
        selectedUserId,
        selectedUserName,
        doDeleteUser,
        setSelectedUpdatedAt,
        setSelectedUserId,
        setSelectedUserName,
        setDeleteConfirmationModalOpen,
        cannotDeleteError,
        setCannotDeleteError,
        currentPage,
        onClear
    }

}